export default "__VITE_ASSET__D1t6kgV8__"